import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { putCoreBusinessContextUploadSlice } from './put';

export const coreAiContextUploadReducers = combineReducers({
	put: putCoreBusinessContextUploadSlice.asyncReducers
});

export const coreAiContextUploadWatchers = combineAllWatchers([
	putCoreBusinessContextUploadSlice.asyncWatchers
]);
